import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { svgIconStyles as s } from "../svg-icon/SvgIcon.styles.js";
function c({
  label: r,
  className: e,
  size: t,
  ...i
}) {
  return /* @__PURE__ */ n(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "arrowUp",
      stroke: "none",
      role: "img",
      "aria-hidden": !r,
      focusable: "false",
      className: s({ className: e, size: t }),
      ...i,
      children: [
        r && /* @__PURE__ */ o("title", { children: r }),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M3.30412 18C2.42219 18 1.96101 16.9516 2.55695 16.3015L12 6L21.443 16.3015C22.039 16.9516 21.5778 18 20.6959 18C20.4118 18 20.1407 17.8808 19.9487 17.6713L12.1474 9.16083C12.0682 9.07436 11.9318 9.07436 11.8526 9.16083L4.05129 17.6713C3.85931 17.8808 3.58823 18 3.30412 18Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  c as ArrowUpIcon,
  c as default
};
